import { create } from "zustand";

/**
 * Which suggested edit is being previewed on the resume right now ("bullet 2, Creative
 * Solutions Inc."), for the pill above the canvas. The previewed value itself lives in the
 * resume store's previewOverlay; this only names it.
 */
type EditPreviewStore = {
  label: string | null;
  show: (label: string) => void;
  clear: () => void;
};

export const useEditPreviewStore = create<EditPreviewStore>()((set) => ({
  label: null,
  show: (label) => set({ label }),
  clear: () => set({ label: null }),
}));
